import type { CSS } from '@components-shared/src/stitches';
import { keyframes, styled, theme } from '@components-shared/src/stitches';

export const loading = keyframes({
  to: { transform: 'rotate(1turn)' },
});

const baseStyle: CSS = {
  borderWidth: '2px',
  borderStyle: 'solid',
  borderBottomColor: 'transparent',
  borderLeftColor: 'transparent',
  animation: `${loading} 0.45s linear infinite`,
};

export const Spinner = styled('div', {
  display: 'flex',
  justifyContent: 'center',

  '&::after': {
    content: '',
    borderRadius: '50%',
    borderColor: 'currentColor',
  },

  variants: {
    size: {
      xs: {
        '&::after': {
          width: '0.75rem',
          height: '0.75rem',
        },
      },
      sm: {
        '&::after': {
          width: '1rem',
          height: '1rem',
        },
      },
      md: {
        '&::after': {
          width: '1.5rem',
          height: '1.5rem',
        },
      },
      lg: {
        '&::after': {
          width: '2rem',
          height: '2rem',
        },
      },
      xl: {
        '&::after': {
          width: '3em',
          height: '3em',
        },
      },
    },
    type: {
      base: {
        '&::after': {
          ...baseStyle,
        },
      },
      trending: {
        marginY: 100,
        '&::after': {
          ...baseStyle,
        },
      },
      fullScreenLoading: {
        '&::after': {
          borderWidth: '4px',
          borderStyle: 'solid',
          borderColor: theme.colors.gray200,
          borderBottomColor: '#6D7180',
          borderLeftColor: '#6D7180',
          animation: `${loading} 0.65s linear infinite`,
        },
      },
      buyModal: {
        marginRight: '4px',

        '&::after': {
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: theme.colors.gray200,
          borderBottomColor: '#6D7180',
          borderLeftColor: '#6D7180',
          animation: `${loading} 0.65s linear infinite`,
        },
      },
    },
  },

  defaultVariants: {
    size: 'md',
    type: 'base',
  },
});
